module.exports = __webpack_public_path__ + "media/images/flags/64/Uruguay-4e132747bd0dde4a378494ef39bea2d2.png";